import React from 'react';
import { setLoad } from '../../components/loading';

export default class Certification extends React.Component {

    componentDidMount = async () => {
        await setLoad(false);
    }

    render() {
        return (<>
            <section className="block-explorer-section section bg-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="center-heading">
                                <h2 className="section-title">Certification</h2>
                            </div>
                        </div>
                        <div className="offset-lg-3 col-lg-6">
                            <div className="center-text">
                                <p>Latest authority certifications issued.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table table-striped table-latests">
                                    <thead>
                                        <tr>
                                            <td>Name</td>
                                            <td>Register</td>
                                            <td>Valid</td>
                                            <td>Address</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>)
    }
}